import React, { useState } from 'react';
import { formatDate } from '../../../utils/DateUtils';
import { useEscapeClose } from '../../../utils/SamuiUtils';
import { useModalKeyboardNavigation, scrollToRow, getKeyboardInstructions } from '../../../utils/ModalKeyboardNavigation';

const ViewHistoryWtItemReturn = ({
    showHistoryModal,
    setShowHistoryModal,
    dataMasterHistoryList,
    filteredDetailHistoryList,
    selectedHistoryRow,
    whHistoryCustName,
    formatCurrency,
    onRowSelectHistory,
    onPageUpdate
}) => {
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    
    useEscapeClose(showHistoryModal, () => setShowHistoryModal(false));
    
    // เพิ่ม keyboard navigation
    useModalKeyboardNavigation(
        showHistoryModal,
        dataMasterHistoryList,
        selectedRowIndex,
        setSelectedRowIndex,
        onRowSelectHistory,
        () => setShowHistoryModal(false)
    );

    const uniqueCustomerList = [...new Set(dataMasterHistoryList.map(item => item.WTDoc_Emp_Name))];

    return (
        showHistoryModal && (
            <div
                className={`modal ${showHistoryModal ? 'show' : ''}`}
                style={{ display: showHistoryModal ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        {/* Header */}
                        <div className="modal-header">
                            <div className="d-flex justify-content-between align-items-center w-100" style={{ padding: '10px' }}>
                                <div className="d-flex align-items-center">
                                    <h4 className="card-title">ประวัติการเบิกสินค้า</h4>
                                </div>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-4 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
                                    <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
                                        <table id="basic-datatables" className="table table-striped table-hover">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: '10%' }}>ลำดับ</th>
                                                    <th className="text-center" style={{ width: '20%' }}>รหัส</th>
                                                    <th className="text-center" style={{ width: '70%' }}>ชื่อ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {uniqueCustomerList.length > 0 ? (
                                                    uniqueCustomerList.map((customer, index) => (
                                                        <tr
                                                            key={index}
                                                            onClick={() => {
                                                                setSelectedRowIndex(index);
                                                                const selectedData = dataMasterHistoryList.find(item => item.WTDoc_Emp_Name === customer);
                                                                if (selectedData) {
                                                                    onRowSelectHistory(selectedData);
                                                                }
                                                            }}
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor:
                                                                    index === selectedRowIndex || selectedHistoryRow === customer
                                                                        ? "rgb(105, 188, 216)"
                                                                        : "transparent",
                                                                transition: "background-color 0.3s ease",
                                                            }}
                                                        >
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{dataMasterHistoryList.find(item => item.WTDoc_Emp_Name === customer)?.WTDoc_Emp_Code}</td>
                                                            <td className="text-left">{customer}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5">
                                                            <center>
                                                                <h5>ไม่พบข้อมูล</h5>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-8 mb-3">
                                    <div className="justify-content-between align-items-center mb-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <p className="card-title mb-0">
                                                    ชื่อลูกค้า: {whHistoryCustName}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                        <table
                                            id="basic-datatables"
                                            className="table table-striped table-hover"
                                            style={{ minWidth: '100%' }}
                                        >
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: '12%' }}>วันที่เอกสาร</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                                                    <th className="text-center" style={{ width: '15%' }}>รหัสสินค้า</th>
                                                    <th className="text-center" style={{ width: '20%' }}>ชื่อสินค้า</th>
                                                    <th className="text-center" style={{ width: '10%' }}>จำนวน</th>
                                                    <th className="text-center" style={{ width: '14%' }}>สถานะ</th>
                                                    <th className="text-center" style={{ width: '2%' }}>
                                                        <i className="fa fa-edit" />
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredDetailHistoryList.length > 0 ? (
                                                    filteredDetailHistoryList.map((item, index) => (
                                                        <tr key={item.DT_Id || index + 1} style={{ cursor: 'pointer', transition: 'background-color 0.3s ease' }}>
                                                            <td className="text-center">{formatDate(item.WTDoc_Date)}</td>
                                                            <td className="text-center">{item.WTDoc_No}</td>
                                                            <td className="text-center">{item.Item_Code}</td>
                                                            <td className="text-left">{item.Item_Name}</td>
                                                            <td className="text-center">{formatCurrency(item.Item_Qty)}</td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn"
                                                                    style={{
                                                                        backgroundColor: item.WTDocStatus_Name === 'ยกเลิก' ? item.WTDocStatus_Colour : item.Item_Is_Return === 0 ? 'rgb(255, 0, 0)' : 'rgb(15, 100, 15)',
                                                                        color: 'white',
                                                                        width: '100%'
                                                                    }}
                                                                >
                                                                    {
                                                                        item.WTDocStatus_Name === 'ยกเลิก' ? (
                                                                            'ยกเลิก'
                                                                        ) : (
                                                                            item.Item_Is_Return === 0 ? 'ยังไม่คืน' : 'คืนแล้ว'
                                                                        )
                                                                    }
                                                                </button>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    hidden={item.WTDocStatus_Name === 'ยกเลิก'}
                                                                    className="btn btn-sm"
                                                                    onClick={() => onPageUpdate(item.WTDoc_No)}
                                                                >
                                                                    <i className="fa fa-edit" />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="14">
                                                            <center>
                                                                <h5>ไม่พบข้อมูล</h5>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer">
                            <div className="text-left" style={{ fontSize: "12px", color: "#666", marginRight: "auto" }}>
                                {getKeyboardInstructions('ประวัติ')}
                            </div>
                            <button type="button" className="btn btn-danger" onClick={() => {
                                setShowHistoryModal(false);
                            }}>
                                ปิด (ESC)
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default ViewHistoryWtItemReturn;